import { createSlice } from '@reduxjs/toolkit';
import type { NormalizedError } from 'errors/types';
import type { RootState } from 'state/store';

export type HeatPumpDetails = {
  firstName: string | null;
  lastName: string | null;
  electricityAccountNumber: string | null;
  email: string | null;
  phoneNumber: string | null;
  address: string | null;
  postcode: string | null;
};

export type HeatPumpRegistrationState = {
  isLoading: boolean;
  errors: null | NormalizedError[];
  details: HeatPumpDetails;
  data: {
    status: string | null;
  };
};

export const initialState: HeatPumpRegistrationState = {
  isLoading: false,
  errors: null,
  details: {
    firstName: null,
    lastName: null,
    electricityAccountNumber: null,
    email: null,
    phoneNumber: null,
    address: null,
    postcode: null
  },
  data: {
    status: null
  }
};

export const slice = createSlice({
  name: 'heatPumpRegistration',
  initialState,
  reducers: {
    setInitialState: (state) => {
      Object.entries(initialState).forEach(
        ([key, value]) => (state[key] = value)
      );
    },
    setIsLoading: (state) => {
      state.isLoading = true;
      state.errors = initialState.errors;
    },
    setSuccess: (state, { payload }) => {
      state.isLoading = false;
      state.data = payload;
      state.errors = initialState.errors;
    },

    setError: (state, { payload }) => {
      state.isLoading = false;
      state.data = { status: null };
      state.errors = payload;
    },
    setFormField: (state, { payload: { name, value } }) => {
      state.details[name] = value;
    }
  }
});

export const {
  setInitialState,
  setFormField,
  setSuccess,
  setError,
  setIsLoading
} = slice.actions;

export const selectSlice = (state: RootState) => state[slice.name];
export const selectDetails = (state: RootState) => selectSlice(state).details;
export const selectIsLoading = (state: RootState) =>
  selectSlice(state).isLoading;
export const selectErrors = (state: RootState) => selectSlice(state).errors;
export const selectData = (state: RootState) => selectSlice(state).data;

export default slice.reducer;
